"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SetOptions;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _actions = require("../actions");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function SetOptions(_ref) {
  var isDataPage = _ref.isDataPage,
      tagIds = _ref.tagIds,
      permissions = _ref.permissions,
      audienceViews = _ref.audienceViews,
      _ref$displaySegmentId = _ref.displaySegmentIds,
      displaySegmentIds = _ref$displaySegmentId === void 0 ? true : _ref$displaySegmentId,
      dataMessage = _ref.dataMessage,
      children = _ref.children;
  var dispatch = (0, _reactRedux.useDispatch)();
  var hasDataPage = (0, _reactRedux.useSelector)(function (state) {
    return state.options.isDataPage.optionSet;
  });
  var hasTagIds = (0, _reactRedux.useSelector)(function (state) {
    return state.options.tagIds.optionSet;
  });
  var hasPermissions = (0, _reactRedux.useSelector)(function (state) {
    return state.options.permissions.optionSet;
  });
  var hasAudienceViews = (0, _reactRedux.useSelector)(function (state) {
    return state.audienceView.optionSet;
  });
  var hasSetDisplaySegments = (0, _reactRedux.useSelector)(function (state) {
    return state.options.displaySegmentIds.optionSet;
  });
  var hasDataMessage = (0, _reactRedux.useSelector)(function (state) {
    return state.options.dataMessage.optionSet;
  });
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.setIsDataPage)(isDataPage));
    dispatch((0, _actions.setAudienceViews)(audienceViews));
    dispatch((0, _actions.setTagIds)(tagIds));
    dispatch((0, _actions.setPermissions)(permissions));
    dispatch((0, _actions.setDisplaySegmentIds)(displaySegmentIds));
    dispatch((0, _actions.setDataMessage)(dataMessage));
  }, [dispatch, isDataPage, tagIds, permissions, audienceViews, displaySegmentIds, dataMessage]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasDataPage && hasTagIds && hasPermissions && hasAudienceViews && hasSetDisplaySegments && hasDataMessage ? children : '');
}